import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import {ContextRouter} from 'react-router-dom';

import {SubmissionError} from 'redux-form';

import {formEncodedApi} from 'nutshell-core/api';
import {Routing} from 'nutshell-core/routing';
import {makeErrorObject} from 'nutshell-core/validation/make-error-object';
import {
    validationErrorCheck,
    ValidationError,
} from 'nutshell-core/validation/validation-error-check';

import {headTitle} from 'shells/document/head-title';

import {SetNewPasswordForm} from './set-new-password-form';

type OwnProps = {
    // We'll show difficult copy accordingly
    isNewUser: boolean;
};

type Props = OwnProps & ContextRouter;

export function SetNewPasswordPage(props: Props) {
    const params = Routing.deparam(props.location.search);
    const username = params ? params.username : '';
    const token = params ? params.token : '';

    return (
        <React.Fragment>
            <Helmet>
                <title>
                    {headTitle(props.isNewUser ? 'Welcome to Nutshell!' : 'Set a new password')}
                </title>
            </Helmet>
            <SetNewPasswordForm
                // @ts-expect-error
                isNewUser={props.isNewUser}
                // @ts-expect-error
                onSubmit={(data) =>
                    handleSubmit({
                        username: username,
                        token: token,
                        ...data,
                    })
                }
            />
        </React.Fragment>
    );
}

// @ts-expect-error
function handleSubmit(formData) {
    const csrfTokenInput = document.querySelector('input[name="nutshell-csrf-token"]');

    return (
        formEncodedApi
            .post(
                '/auth/reset-password',
                {
                    username: formData.username,
                    token: formData.token,
                    password: formData.password,
                    passwordConfirm: formData.passwordConfirm,
                    // @ts-expect-error
                    csrf: csrfTokenInput ? csrfTokenInput.value : '',
                },
                {redirect: 'follow'}
            )
            .then((res) => {
                // @ts-expect-error
                if (res && res.redirected) {
                    // @ts-expect-error
                    window.location.href = res.url;
                }

                return res;
            })
            // @ts-expect-error
            .then(validationErrorCheck)
            // @ts-expect-error
            .then((res) => res.json())
            .catch((err: Error) => {
                // @ts-expect-error
                if (err instanceof ValidationError && err.validationResult) {
                    throw new SubmissionError(makeErrorObject(err));
                }
            })
    );
}
